<template>
  <div style="overflow:hidden;" class="mainbox">
    <div class="anliyixiabox">
      <div class="anliyixialeft">
        <div class="anliyixiatopbox">
          <dl class="anlitopnrdl">
            <dt>“ 寻求一碗安利 ”</dt>
            <dd>不限主题，可以寻求牛人推荐、寻求达人安利、寻求专家指导、寻求SOS，需要答疑解惑，或者分享你的观点...</dd>
          </dl>
        </div>

        <div class="anliyixialeftbox">
          <div class="yiwanbox">
            <Timeline>
              <TimelineItem color="#ffa200">
                <div class="yiwanlist">
                  <div class="yiwanlistleft">
                    <h5>@tree</h5>
                    <span>12分钟前</span>
                  </div>
                  <div class="yiwanlistright">
                    <div class="yiwannrbox">
                      <p>帮忙安利一个好用的充电宝。要那种好用的，又不容易坏的。</p>
                    </div>
                    <div class="yiwannrping">
                      <ul>
                        <li>
                          <img :src="anliyxicon01" />
                          <span>255 赞</span>
                        </li>
                        <li>
                          <img :src="anliyxicon02" />
                          <span>50 踩</span>
                        </li>
                        <li>
                          <img :src="anliyxicon03" />
                          <span>200 快评</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </TimelineItem>
              <TimelineItem color="#ffa200">
                <div class="yiwanlist">
                  <div class="yiwanlistleft">
                    <h5>@tree</h5>
                    <span>12分钟前</span>
                  </div>
                  <div class="yiwanlistright">
                    <div class="yiwannrbox">
                      <p>一个以前玩的很好的女性朋友（中间因为高中上寄宿学校，管的很严基本没与外界联系），前段时间无聊刷手机看看朋友圈，发现她朋友圈是那种不给看的标志，然后背景图也是空的，头像也换成黑的。我以为遭受了什么打击，到昨天试验了一下微信的朋友权限调成仅聊天，跟我看她的一模一样，想不通为啥子。</p>
                    </div>
                    <div class="yiwannrping">
                      <ul>
                        <li>
                          <img :src="anliyxicon01" />
                          <span>255 赞</span>
                        </li>
                        <li>
                          <img :src="anliyxicon02" />
                          <span>50 踩</span>
                        </li>
                        <li @click="openkuaiping">
                          <img :src="anliyxicon03" />
                          <span>200 快评</span>
                        </li>
                      </ul>
                    </div>
                    <div :class="openkuai == 'true' ? 'kuaipingbox' : 'kuaipingbox closekuai'">
                      <div class="kuaipinglist">
                        <dl>
                          <dt>
                            <span>#1楼</span>@你的大哥哥
                          </dt>
                          <dd>能听懂就行</dd>
                        </dl>
                        <div class="kuaipingping">
                          <ul>
                            <li>
                              <img :src="anliyxicon01" />
                              <span>25 赞</span>
                            </li>
                            <li>
                              <img :src="anliyxicon02" />
                              <span>50 踩</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="kuaipinglist">
                        <dl>
                          <dt>
                            <span>#1楼</span>@你的大哥哥
                          </dt>
                          <dd>能听懂就行</dd>
                        </dl>
                        <div class="kuaipingping">
                          <ul>
                            <li>
                              <img :src="anliyxicon01" />
                              <span>25 赞</span>
                            </li>
                            <li>
                              <img :src="anliyxicon02" />
                              <span>50 踩</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="kuaipinglist">
                        <dl>
                          <dt>
                            <span>#1楼</span>@你的大哥哥
                          </dt>
                          <dd>能听懂就行</dd>
                        </dl>
                        <div class="kuaipingping">
                          <ul>
                            <li>
                              <img :src="anliyxicon01" />
                              <span>25 赞</span>
                            </li>
                            <li>
                              <img :src="anliyxicon02" />
                              <span>50 踩</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="kuaipinghuifu">
                        <ul>
                          <li>
                            <dl>
                              <dt>昵称：</dt>
                              <dd>
                                <Input v-model="formItem.username" placeholder="请输入昵称"></Input>
                              </dd>
                            </dl>
                          </li>
                          <li>
                            <dl>
                              <dt>邮箱：</dt>
                              <dd>
                                <Input v-model="formItem.email" placeholder="请输入邮箱"></Input>
                              </dd>
                            </dl>
                          </li>
                          <li>
                            <Input
                              v-model="formItem.textarea"
                              class="textarea"
                              type="textarea"
                              :autosize="{minRows: 3,maxRows: 8}"
                              placeholder="请输入求安利，求推荐，SOS具体内容..."
                            ></Input>
                          </li>
                          <li>
                            <span>确定发布</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </TimelineItem>
              <TimelineItem color="#ffa200">
                <div class="yiwanlist">
                  <div class="yiwanlistleft">
                    <h5>@大魔王周周</h5>
                    <span>12分钟前</span>
                  </div>
                  <div class="yiwanlistright">
                    <div class="yiwannrbox">
                      <p>帮忙安利一部电影，看着想睡觉那种。</p>
                    </div>
                    <div class="yiwannrping">
                      <ul>
                        <li>
                          <img :src="anliyxicon01" />
                          <span>5 赞</span>
                        </li>
                        <li>
                          <img :src="anliyxicon02" />
                          <span>2 踩</span>
                        </li>
                        <li>
                          <img :src="anliyxicon03" />
                          <span>30 快评</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </TimelineItem>
              <TimelineItem color="#ffa200">
                <div class="yiwanlist">
                  <div class="yiwanlistleft">
                    <h5>@大魔王周周</h5>
                    <span>12分钟前</span>
                  </div>
                  <div class="yiwanlistright">
                    <div class="yiwannrbox">
                      <p>帮忙安利一部电影，看着想睡觉那种。</p>
                    </div>
                    <div class="yiwannrping">
                      <ul>
                        <li>
                          <img :src="anliyxicon01" />
                          <span>5 赞</span>
                        </li>
                        <li>
                          <img :src="anliyxicon02" />
                          <span>2 踩</span>
                        </li>
                        <li>
                          <img :src="anliyxicon03" />
                          <span>30 快评</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </TimelineItem>
              <TimelineItem color="#ffa200">
                <div class="yiwanlist">
                  <div class="yiwanlistleft">
                    <h5>@大魔王周周</h5>
                    <span>12分钟前</span>
                  </div>
                  <div class="yiwanlistright">
                    <div class="yiwannrbox">
                      <p>帮忙安利一部电影，看着想睡觉那种。</p>
                    </div>
                    <div class="yiwannrping">
                      <ul>
                        <li>
                          <img :src="anliyxicon01" />
                          <span>5 赞</span>
                        </li>
                        <li>
                          <img :src="anliyxicon02" />
                          <span>2 踩</span>
                        </li>
                        <li>
                          <img :src="anliyxicon03" />
                          <span>30 快评</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </TimelineItem>
            </Timeline>
          </div>
        </div>
      </div>
      <div class="anliyixiaright">
        <Affix :offset-top="60">
        <div class="qiuanlibox">
          <div class="qiuanlitopbox">
            <dl>
              <dt>
                <img :src="qiuanlitop" />
              </dt>
              <dd>求安利，求推荐，SOS,或者想说点什么...</dd>
            </dl>
          </div>
          <div class="qiuanlimainbox">
            <ul>
              <li>
                <dl>
                  <dt>昵称：</dt>
                  <dd>
                    <Input v-model="formItem.username" placeholder="请输入昵称"></Input>
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>邮箱：</dt>
                  <dd>
                    <Input v-model="formItem.email" placeholder="请输入邮箱"></Input>
                  </dd>
                </dl>
              </li>
              <li>
                <Input
                  v-model="formItem.textarea"
                  class="textarea"
                  type="textarea"
                  :autosize="{minRows: 3,maxRows: 8}"
                  placeholder="请输入求安利，求推荐，SOS具体内容..."
                ></Input>
              </li>
              <li>
                <span>确定发布</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="gonggaobox">
            <dl>
                <dt>公告</dt>
                <dd>站内发布安利及评论皆为人工审核，如有违规内容请站内举报或邮件联系. <br/>jubao@anliqu.com。</dd>
            </dl>  
        </div>
        </Affix>
      </div>

    </div>

    <div class="footerbox"></div>

    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
let num = 0;
export default {
  components: { addweb },
  data() {
    return {
      openkuai: false,
      anlifbicon: require("@/assets/images/fbicon.png"),
      anliyxpic: require("@/assets/images/anliyxpic.jpg"),
      anliyxicon01: require("@/assets/images/anliyxicon001.gif"),
      anliyxicon02: require("@/assets/images/anliyxicon002.gif"),
      anliyxicon03: require("@/assets/images/anliyxicon003.gif"),
      zxxqanlibg: require("@/assets/images/zxalibox.gif"),
      zxxqanlisx: require("@/assets/images/shuaxianicon.gif"),
      qiuanlitop: require("@/assets/images/qaltoppic.gif"),
      //展示快评
      nid: "1",
      formItem: {
        username: "",
        email: "",
        textarea: ""
      }
    };
  },
  created() {
    window.scrollTo(0, 0);
    //this.showkuai == false;
  },
  mounted() {
    console.log('id',this.$route.query.id)

  },
  methods: {
    gotolabeldetails() {
      this.$router.push({
        name: "labeldetails"
      });
    },
    openkuaiping() {
      console.log("555", this.openkuai);
      if (num % 2 == 1) {
        this.openkuai = "false";
      } else {
        this.openkuai = "true";
      }

      num++;
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding-top: 60px;
}
html,
body {
  height: 100%;
}

.anliyixiabox {
  width: 1300px;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
  .anliyixialeft {
    width: 950px;
    margin-left: 5px;
    float: left;
    padding-top: 20px;
    padding-bottom: 50px;
    .anliyixiatopbox {
      width: 940px;
      height: 130px;
      background: #f7f7f7;
      .anlitopbtndl {
        float: right;
        width: 197px;
        height: 50px;
        border: 1px solid #ffa200;
        background: #fff;
        border-radius: 30px;
        margin-top: 46px;
        margin-right: 25px;
        dt {
          float: left;
          padding-left: 46px;
          padding-top: 12px;
        }
        dd {
          float: left;
          font-size: 18px;
          padding-top: 10px;
          color: #ffa200;
          padding-left: 10px;
        }
      }
      .anlitopnrdl {
        float: left;
        dt {
          font-size: 26px;
          padding-left: 20px;
          color: #434343;
          font-weight: bold;
          padding-top: 30px;
        }
        dd {
          font-size: 14px;
          color: #999;
          padding-left: 53px;
          padding-top: 10px;
        }
      }
    }

    .yiwanbox {
      padding-top: 38px;
      padding-left: 10px;

      .yiwanlist {
        overflow: hidden;
        padding-bottom: 10px;

        .yiwanlistleft {
          float: left;
          width: 160px;
          h5 {
            font-size: 16px;
            line-height: 18px;
          }
          span {
            padding-top: 5px;
            display: block;
            color: #999;
            font-size: 13px;
          }
        }
        .yiwanlistright {
          border-bottom: 1px solid #f8f8f8;
          overflow: hidden;
          padding-bottom: 20px;
          width: 743px;
          float: left;
          margin-left: 5px;

          .yiwannrbox {
            float: left;
            text-align: left;
            width: 100%;
          }

          .yiwannrping {
            clear: both;
            ul {
              padding-top: 18px;
              float: right;
              padding-right: 10px;
              overflow: hidden;
              padding-bottom: 15px;
              li {
                cursor: pointer;
                float: left;
                padding-left: 30px;
                img {
                  float: left;
                  margin-top: 1px;
                }
                span {
                  float: left;
                  color: #666;
                  padding-left: 10px;
                  font-size: 13px;
                }
              }
            }
          }

          .kuaipingbox {
            height: auto;
            border: 1px solid #eee;
            transition: 1s;
            border-bottom: none;
            clear: both;
            overflow: hidden;
            margin-bottom: 10px;
            .kuaipinglist {
              padding: 15px 20px;
              border-bottom: 1px solid #eee;
              overflow: hidden;
              dl {
                dt {
                  font-weight: bold;
                  font-size: 15px;
                  span {
                    float: right;
                    font-weight: normal;
                    color: #999;
                    font-size: 13px;
                  }
                }

                dd {
                  font-size: 13px;
                  padding-top: 10px;
                }
              }

              .kuaipingping {
                ul {
                  padding-top: 5px;
                  float: right;
                  padding-right: 0px;
                  overflow: hidden;
                  padding-bottom: 10px;
                  li {
                    float: left;
                    padding-left: 30px;
                    img {
                      float: left;
                      margin-top: 1px;
                    }
                    span {
                      float: left;
                      color: #999;
                      padding-left: 10px;
                      font-size: 13px;
                    }
                  }
                }
              }
            }

            .kuaipinghuifu {
              padding-top: 20px;
              padding-bottom: 20px;
              padding-right: 20px;
              border-bottom: 1px solid #eee;
              ul {
                clear: both;
                padding-left: 10px;
                li {
                  clear: both;
                  padding-left: 15px;
                  width: 100%;
                  padding-bottom: 10px;
                  >>> .ivu-input:hover {
                    border-color: #ffa200;
                  }
                  >>> .ivu-input:focus {
                    border-color: #ffa200;
                  }
                  dl {
                    overflow: hidden;
                    dt {
                      float: left;
                      font-size: 13px;
                      padding-top: 6px;
                    }
                    dd {
                      float: left;
                      width: 500px;
                    }
                  }
                  .textarea textarea {
                    height: 60px;
                  }
                  span {
                    display: block;
                    text-align: center;
                    border: 1px solid #e1e1e1;
                    line-height: 35px;
                    background: #f8f8f8;
                    cursor: pointer;
                  }
                }
              }
            }
          }

          .closekuai {
            height: 0;
            opacity: 0;
          }
        }
      }
    }
  }
  .anliyixiaright {
    width: 343px;
    float: left;
    .zxxqanli {
      width: 324px;
      height: 541px;
      float: right;
      overflow: hidden;
      margin-top: 22px;
      .zxxqanlitop {
        dl {
          dt {
            color: #fff;
            padding-left: 20px;
            padding-top: 32px;
            font-size: 15px;
          }
          dd {
            float: right;
            padding-right: 30px;
            padding-top: 1px;
          }
        }
      }
      .zxxqanlilistbox {
        margin-left: 20px;
        padding-top: 20px;
        height: 375px;
        overflow: hidden;
        clear: both;
        padding-right: 25px;
        .time {
          color: #999;
          padding: 0;
          line-height: 18px;
          padding-bottom: 5px;
        }
        .content {
          color: #333;
        }
      }

      .morexqal {
        padding-top: 30px;
        padding-left: 20px;
        padding-right: 20px;
        span {
          border: 1px solid #ffa200;
          text-align: center;
          display: block;
          color: #ffa200;
          line-height: 36px;
          font-size: 15px;
        }
      }
    }

    .qiuanlibox {
      border: 1px solid #e1e1e1;
      width: 323px;
      clear: both;
      margin-top: 20px;
      float: right;
      padding-bottom: 10px; margin-bottom: 20px;
      .qiuanlitopbox {
        dl {
          dt {
            text-align: center;
          }
          dd {
            text-align: center;
            font-weight: bold;
            font-size: 15px;
            padding-top: 10px;
          }
        }
      }

      .qiuanlimainbox {
        clear: both;
        padding-top: 20px;
        ul {
          clear: both;
          padding-left: 10px;
          li {
            clear: both;
            padding-left: 15px;
            width: 292px;
            padding-bottom: 10px;
            >>> .ivu-input:hover {
              border-color: #ffa200;
            }
            >>> .ivu-input:focus {
              border-color: #ffa200;
            }
            dl {
              overflow: hidden;
              dt {
                float: left;
                font-size: 13px;
                padding-top: 6px;
              }
              dd {
                float: right;
                width: 230px;
              }
            }
            .textarea textarea {
              height: 60px;
            }
            span {
              display: block;
              text-align: center;
              border: 1px solid #e1e1e1;
              line-height: 35px;
              background: #f8f8f8;
              cursor: pointer;
            }
          }
        }
      }
    }

    .gonggaobox{ clear: both; border: 1px solid #e1e1e1;margin-left:20px;
      dl{ padding: 20px;
        dt{ font-weight: bold; font-size: 18px;}
        dd{ font-size: 13px; padding-top: 12px; line-height:23px;}
      }
    }


  }
}

.footerbox {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/yiwan.vue